import React, { useState, useEffect } from "react";
import { useSpring, animated } from "react-spring";
import { ethers } from "ethers";
import { useEstimatePricePerCredit } from "../utils/hooks";

export default function LiveRate() {
  const {
    data: priceForOneToken,
    isLoading,
    isError,
  } = useEstimatePricePerCredit();

  const [pepecoinsRequiredPerCredit, setPepecoinsRequiredPerCredit] =
    useState("0");
  const [prevPepecoins, setPrevPepecoins] = useState("0");

  useEffect(() => {
    if (priceForOneToken) {
      const formatted = ethers.formatUnits(priceForOneToken, 18);
      setPepecoinsRequiredPerCredit(formatted);
    }
  }, [priceForOneToken]);

  const { number } = useSpring({
    number: parseFloat(pepecoinsRequiredPerCredit),
    from: { number: parseFloat(prevPepecoins) },
    reset: true,
    onRest: () => setPrevPepecoins(pepecoinsRequiredPerCredit),
  });

  if (isLoading || isError || pepecoinsRequiredPerCredit === "0") return null;

  return (
    <div className="font-mono small text-uppercase">
      1 Brain Credit ={" "}
      <animated.span>{number.to((n) => n.toFixed(2))}</animated.span> Pepecoin
    </div>
  );
}
